import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useState } from 'react';
import { Button, CodeBlock } from '@cimpress/react-components';
import { BatonTransmissionDetails } from '../../common/batonTransmissionDetails';
import { getI18nInstance } from '../../../locales/i18n';
export const SiteFlowTransmissionDetails = ({ transmissionDetails, language }) => {
    var _a;
    const t = getI18nInstance().getFixedT(language);
    const [showMore, setShowMore] = useState(false);
    const transmissionResult = (_a = transmissionDetails === null || transmissionDetails === void 0 ? void 0 : transmissionDetails._embedded) === null || _a === void 0 ? void 0 : _a.transmissionExecutionDetails;
    if (!transmissionResult) {
        return _jsx(_Fragment, { children: "N/A" });
    }
    const getTransmissionDetails = () => {
        var _a, _b, _c, _d;
        const transmissionExecutionPayload = {
            status: transmissionResult === null || transmissionResult === void 0 ? void 0 : transmissionResult.status,
            message: transmissionResult === null || transmissionResult === void 0 ? void 0 : transmissionResult.message
        };
        if ((transmissionResult === null || transmissionResult === void 0 ? void 0 : transmissionResult.status) !== 200) {
            const description = `${(_b = (_a = transmissionResult === null || transmissionResult === void 0 ? void 0 : transmissionResult.payload) === null || _a === void 0 ? void 0 : _a.error) === null || _b === void 0 ? void 0 : _b.message} 
             - ${(_d = (_c = transmissionResult === null || transmissionResult === void 0 ? void 0 : transmissionResult.payload) === null || _c === void 0 ? void 0 : _c.error) === null || _d === void 0 ? void 0 : _d.details}`;
            transmissionExecutionPayload.description = description;
        }
        return _jsx(BatonTransmissionDetails, { transmissionDetails: transmissionExecutionPayload, language: language });
    };
    return _jsxs(_Fragment, { children: [getTransmissionDetails(), _jsx(Button, Object.assign({ variant: 'anchor', onClick: () => {
                    setShowMore(!showMore);
                } }, { children: showMore ? t('itemTransmission.hideJson') : t('itemTransmission.viewJson') })), showMore && _jsx(CodeBlock, { code: JSON.stringify(transmissionDetails, null, 2) })] });
};
